<template>
  <div class="content">
    <PageTabs :open="open" @change="changeRoute"></PageTabs>
    <div class="map_warp" v-if="toRefreshMap">
      <!-- 地图工具 -->
      <div class="top_tool">
        <!-- 地图搜索工具 -->
        <map-search-tool @setType="setType" @getRelated="getRelated"></map-search-tool>
        <!-- 图层管理 -->
        <map-layer-tool ref="layerTool" @setLayer="setLayer" :colorRang="colorRang"></map-layer-tool>
        <!-- 重置地图 -->
        <div class="reset_btn">
          <el-tooltip effect="light" content="重置地图" placement="bottom">
            <div class="btn" @click="reload"></div>
          </el-tooltip>
        </div>
      </div>
      <!-- 地图组件 -->
      <gd-map ref="child_map" :searchType="searchType" @autoPlay="playTimeline" @setColorRang="setColorRang"
        @changeDetail="changeDetail" @openLoading="openLoading" @backDetail="backDetail" @toPrevLevel="toPrevLevel"
        @drillMap="drillMap"></gd-map>
      <!-- 时间轴 -->
      <div class="timeline_silder" v-if="showTimeLine">
        <div class="loop_icon" :class="{ 'active': play }" @click="play = !play; playTimeline()"></div>
        <el-slider v-model="timeline" :min="0" :max="12" :format-tooltip="formatTooltip" :show-tooltip="showTooltip">
        </el-slider>
      </div>
      <!-- 地图详情 -->
      <map-feature-detail ref="feature_detail" @toPrevLevel="toPrevLevel" @getRelated="getRelated" @getAera="getAera"
        @drillMap="drillMap" @getPrevInfo="getPrevInfo"></map-feature-detail>
    </div>
  </div>
</template>

<script>
import PageTabs from './components/page_tabs.vue'
import GdMap from './components/maps/gdMap.vue';
import MapSearchTool from './components/maps/mapSearchTool.vue';
import MapLayerTool from './components/maps/mapLayerManage.vue';
import MapFeatureDetail from './components/maps/featureDetail.vue'

export default {
  name: 'portraitHome',
  components: {
    PageTabs,
    GdMap,
    MapSearchTool,
    MapLayerTool,
    MapFeatureDetail
  },
  data() {
    return {
      open: false,
      toRefreshMap: true,
      showRank: false,
      showTooltip: true,
      timeline: 1,
      showTimeLine: false,
      play: false,
      loop: null,
      searchType: '',
      colorRang: [],
      fullscreenLoading: null
    };
  },
  // 关闭高德地图弹窗
  beforeRouteLeave(to, from, next) {
    if (this.$refs.child_map.tipsNotify) {
      this.$refs.child_map.tipsNotify.close()
    }
    next()
  },
  methods: {
    // 切换页面
    changeRoute(flag) {
      this.open = flag
      let path = '', queryInfo = this.$route.query
      if (flag) {
        path = '/portrait/salesmanList'
      } else {
        path = '/portrait/portraitHome'
      }
      // 跳转
      this.$router.push({ path: path, query: queryInfo })
    },
    // 设置查询类型
    setType(row) {
      this.searchType = row.type
      // if (this.$refs.layerTool) {
      //   this.setLayerType(Number(row.type))
      // }
    },
    // 搜索类型与对应图层 显示联动
    setLayerType(type) {
      if (!this.$refs.layerTool.layerList[type - 1].visible) {
        this.$refs.layerTool.layerList[type - 1].visible = true
        let layerList = this.$refs.layerTool.layerList
        let term = this.$refs.layerTool.checkedType
        this.setLayer({ list: layerList, terminal: term }, false)
      }
    },
    // 设置图层列表
    setLayer(search, reset) {
      let list = []
      if (search) {
        search.list.map((item, i) => {
          item.visible && list.push(item.id)
          if (!reset) {
            this.$refs.child_map.layerList[i].visible = item.visible
            this.$refs.feature_detail.chartsList[i].visible = item.visible
          }
        })
      }

      if (reset) {
        this.$refs.child_map.layerList = [...this.$refs.child_map.layerList, ...search.list]
        this.$refs.feature_detail.chartsList = this.$refs.child_map.layerList
        this.$refs.child_map.listParams.type = list
        this.$refs.child_map.listParams.terminalType = search.terminal
        this.changeDetail(this.$refs.child_map.listParams)
      } else {
        this.$refs.child_map.changeLayerVisible()
        if (
          this.$refs.child_map.listParams.terminalType.join() != search.terminal.join() ||
          this.$refs.child_map.listParams.type.join() != list.join()
        ) {
          this.$refs.child_map.listParams.type = list
          this.$refs.child_map.listParams.terminalType = search.terminal
          this.$refs.child_map.getLayerList()
          if ((this.$refs.child_map.layerList[3] && this.$refs.child_map.layerList[3].layer) || (this.$refs.child_map.hlLayer && this.$refs.child_map.hlLayer.getMap())) return
          this.changeDetail(this.$refs.child_map.listParams)
        }
      }
    },
    // 设置终端图例数据
    setColorRang(rang) {
      this.colorRang = rang
    },
    // 地图重置
    reload() {
      this.toRefreshMap = false;
      this.$nextTick(() => {
        this.toRefreshMap = true;
      })
    },
    openLoading(flag) {
      if (flag) {
        this.fullscreenLoading = this.$loading({
          lock: true,
          text: '正在加载中...',
          background: 'rgba(0, 0, 0, 0.75)',
          customClass: 'map_loading',
          fullscreen: true
        });
      } else {
        this.fullscreenLoading.close()
        this.fullscreenLoading = null
      }
    },
    // 统计图点击下钻
    drillMap(row) {
      let extData = { externalAttributes: { level: row.level }, adcode: row.code, name: row.name }
      this.$refs.child_map.refreshMap('down', extData)
    },
    // 更新地图详情面板
    changeDetail(row, info) {
      if (info) this.$refs.feature_detail.showDetailPanel = true
      if (info && info.toFit == true) return
      this.$refs.feature_detail.getDetailInfo(row)
      if (info) {
        this.$refs.feature_detail.aeraInfo.name = info.prev
        if (row.code == '') {
          this.$refs.feature_detail.aeraInfo.level = 'coun'
        } else {
          if (info.down) {
            if (row.code == 500000 || row.code == 110000 || row.code == 120000 || row.code == 310000) { // 直辖市
              this.$refs.feature_detail.aeraInfo.level = 'city'
            } else {
              this.$refs.feature_detail.aeraInfo.level = row.level == 1 ? 'prov' : row.level == 2 ? 'city' : 'dist'
            }
          } else {
            let currLevel = info.toFit ? 'dist' : this.$refs.feature_detail.aeraInfo.level
            if (currLevel == 'prov') {
              this.$refs.feature_detail.aeraInfo.level = 'coun'
            } else if (currLevel == 'city') {
              this.$refs.feature_detail.aeraInfo.level = 'prov'
            } else if (currLevel == 'dist') {
              this.$refs.feature_detail.aeraInfo.level = 'city'
            } else if (currLevel == 'town') {
              this.$refs.feature_detail.aeraInfo.level = 'dist'
            }
          }
        }
        this.$refs.feature_detail.currAeraName = info.curr
        this.$refs.feature_detail.showBackBtn = info.down || row.code != '' ? true : false
      }
    },
    // 返回上一级
    toPrevLevel(row) {
      let info = row ? row : this.$refs.feature_detail.aeraInfo
      this.$refs.child_map.refreshMap(info)
      this.$refs.feature_detail.activeName = ''
    },
    // 获取上一级数据 跳转至列表页
    getPrevInfo(route, type) {
      let queryInfo = this.$route.query, path = '/portrait/salesmanList'
      this.open = true
      let info = {}
      if (this.$refs.child_map.channelName == '') {
        let prevInfo = this.$refs.child_map.prevFeature.map(item => {
          return item.name ? JSON.stringify(item) : JSON.stringify(item.getExtData().properties)
        })
        info = prevInfo.join(' ')
      } else {
        let prevInfo = this.$refs.child_map.channelMapInfo.prevFeature.map(item => {
          return item.name ? JSON.stringify(item) : JSON.stringify(item.getExtData().properties)
        })
        info = prevInfo.join(' ')
      }
      queryInfo.data = info
      queryInfo.type = type
      queryInfo.from = 'home'
      queryInfo.toRoute = route
      let pathInfo = this.$router.resolve({
        path: path,
        query: queryInfo
      })
      window.open(pathInfo.href, '_blank');
    },
    // 查询相关数据 显示详情及地图点
    getRelated(row, info) {
      this.$refs.child_map.getDetailLayer(row)
      if (info) {
        this.$refs.feature_detail.showDetailPanel = true
        this.$refs.feature_detail.showBackBtn = false
        this.changeDetail(info)
      }
    },
    // 更新地图区域
    getAera(row) {
      this.$refs.child_map.listParams.code = row.code
      this.$refs.child_map.listParams.level = row.level
      this.$refs.child_map.getLayerList()
    },
    // 返回显示详情
    backDetail(row) {
      this.$refs.child_map.getDetailLayer({ id: row.id, type: row.type, toPosit: true })
      this.$refs.feature_detail.getDetailInfo(row)
    },
    formatTooltip(val) {
      if (val > 0) {
        this.showTooltip = true
        return '2022年' + val + '月';
      } else {
        this.showTooltip = false
      }
    },
    playTimeline() {
      if (this.play) {
        let timer = setInterval(() => {
          if (this.timeline < 12) {
            this.timeline++
          } else {
            this.timeline = 1
          }
        }, 1000)
        if (this.loop == null) {
          this.loop = timer
        }
      } else {
        clearInterval(this.loop)
        this.loop = null
      }
    }
  }
}
</script> 
<style lang="less" scoped>
.content {
  width: 100%;
  height: calc(100% - 37px);
  margin: 0;
  overflow: hidden;
}

.map_warp {
  width: 100%;
  height: 100%;
  position: relative;

  .top_tool {
    width: 100%;
    position: absolute;
    top: .5rem;
    left: 0;
    z-index: 20;

    /deep/.el-divider--vertical {
      margin: 0;
      background-color: #d9d9d9;
    }
  }

  /deep/.el-tabs {
    &__header {
      margin-bottom: 10px;
    }

    .el-tabs__item {
      padding: 0 10px;
      height: 30px;
      line-height: 30px;

      &:first-child {
        padding-left: 10px;
      }

      &.is-active {
        color: #4FA1A4;
      }
    }
  }

  .reset_btn {
    position: absolute;
    top: 0;
    right: 0.5rem;
    box-shadow: 0px 3px 8px 1px rgba(0, 0, 0, .06);

    /deep/.el-tooltip.btn {
      width: 32px;
      height: 32px;
      border: 1px solid #fff;
      border-radius: 2px;
      background: url('../../assets/map/reset_icon_def.png') center/80% no-repeat #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.timeline_silder {
  position: absolute;
  width: 80%;
  left: 10%;
  bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .loop_icon {
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    border-radius: 100%;
    background: url('../../assets/play.png') center / 100% no-repeat #fff;
    cursor: pointer;
    transition: all .3s;

    &.active {
      background: url('../../assets/stop.png') center / 100% no-repeat #fff;
    }
  }

  /deep/.el-slider {
    width: calc(100% - 50px);

    .el-slider__runway {
      height: 4px;
      background-color: #909090;
    }

    .el-slider__button {
      width: 8px;
      height: 8px;
      background: #FFFFFF;
      border: 2px solid rgba(211, 211, 211, 1);
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      border-radius: 100%;
    }

    .el-slider__bar {
      height: 4px;
    }
  }
}
</style>